import m from "./../../../dist/es2015/themes/Micro.js";
export const am5themes_Micro = m;